/** @format */

import React, { useState } from "react";
import "./index.scss";
import toast from "react-hot-toast";

const expressionOptions = [
  { name: "Greater than or equal to", value: "greater_than_or_equal_to" },
  { name: "Greater than", value: "greater_than" },
];
const discountTypeOptions = [
  { name: "Percentage", value: "percentage" },
  { name: "Absolute", value: "absolute" },
];

const EditSVG = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4361EE" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteSVG = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D90429" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const CheckSVG = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2D6B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function OfferCardMobile({
  isEdit,
  handleOffer,
  data,
  setAdding,
  handleDeleteOffer,
  checkIsFieldChanged,
}) {
  const [isEditting, setIsEditting] = useState(false);
  const [values, setValues] = useState({
    offer_name: isEdit ? data.offer_name : "",
    bool_exp: isEdit ? data.bool_exp : "greater_than_or_equal_to",
    offer_type: "based_on_order_value",
    discount_type: isEdit ? data.discount_type : "percentage",
    discount_val: isEdit ? data.discount_val : "",
    status: isEdit ? data.status : true,
    offer_value: isEdit ? data.offer_value : "",
    maximum_allowed_discount: isEdit ? data.maximum_allowed_discount : "",
  });

  const set = (key, val) => setValues((p) => ({ ...p, [key]: val }));

  const getExprLabel = (v) => expressionOptions.find((e) => e.value === v)?.name || v;

  const handleSubmit = () => {
    if (!isEdit) {
      // create
      handleOffer(values);
    } else if (!isEditting) {
      setIsEditting(true);
    } else {
      // save edit
      if (!checkIsFieldChanged(data?.offer_id, values)) {
        toast.error("Please change any field to update");
        return;
      }
      handleOffer({ ...values, offer_id: data.offer_id });
      setIsEditting(false);
    }
  };

  const handleCancel = () => {
    if (!isEdit) {
      setAdding(false);
    } else {
      setIsEditting(false);
      setValues({
        offer_name: data.offer_name,
        bool_exp: data.bool_exp,
        offer_type: "based_on_order_value",
        discount_type: data.discount_type,
        discount_val: data.discount_val,
        status: data.status,
        offer_value: data.offer_value,
        maximum_allowed_discount: data.maximum_allowed_discount,
      });
    }
  };

  const isFormMode = !isEdit || isEditting;

  return (
    <div className="ocm-card">
      {/* ── VIEW MODE ── */}
      {isEdit && !isEditting && (
        <>
          <div className="ocm-header">
            <span className="ocm-name">{data.offer_name}</span>
            <span className={`ocm-badge ${data.status ? "ocm-badge--active" : "ocm-badge--inactive"}`}>
              {data.status ? "Active" : "Inactive"}
            </span>
          </div>

          <div className="ocm-details">
            <div className="ocm-row">
              <span className="ocm-label">Order value</span>
              <span className="ocm-value">&#8377; {data.offer_value}</span>
            </div>
            <div className="ocm-row">
              <span className="ocm-label">Condition</span>
              <span className="ocm-value">{getExprLabel(data.bool_exp)}</span>
            </div>
            <div className="ocm-row">
              <span className="ocm-label">Discount</span>
              <span className="ocm-value">
                {data.discount_type === "percentage"
                  ? `${data.discount_val}%`
                  : `\u20B9 ${data.discount_val}`}
              </span>
            </div>
            {data.discount_type === "percentage" && Number(data.maximum_allowed_discount) > 0 && (
              <div className="ocm-row">
                <span className="ocm-label">Max discount</span>
                <span className="ocm-value">&#8377; {data.maximum_allowed_discount}</span>
              </div>
            )}
          </div>

          <div className="ocm-actions">
            <button className="ocm-icon-btn ocm-icon-btn--edit" onClick={() => setIsEditting(true)} title="Edit">
              <EditSVG />
            </button>
            <button className="ocm-icon-btn ocm-icon-btn--delete" onClick={handleDeleteOffer} title="Delete">
              <DeleteSVG />
            </button>
          </div>
        </>
      )}

      {/* ── EDIT / CREATE FORM MODE ── */}
      {isFormMode && (
        <div className="ocm-form">
          {/* Offer name */}
          <div className="ocm-field">
            <label className="ocm-field-label">Offer name</label>
            <input
              className="ocm-input"
              type="text"
              placeholder="Eg: Offer 1"
              value={values.offer_name}
              onChange={(e) => set("offer_name", e.target.value)}
            />
          </div>

          {/* Order value */}
          <div className="ocm-field">
            <label className="ocm-field-label">Order value</label>
            <div className="ocm-input-prefix">
              <span className="ocm-prefix-symbol">&#8377;</span>
              <input
                type="number"
                placeholder="Eg: 100"
                value={values.offer_value}
                onChange={(e) => set("offer_value", e.target.value)}
              />
            </div>
          </div>

          {/* Boolean expression */}
          <div className="ocm-field">
            <label className="ocm-field-label">Condition</label>
            <select
              className="ocm-select"
              value={values.bool_exp}
              onChange={(e) => set("bool_exp", e.target.value)}>
              {expressionOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.name}</option>
              ))}
            </select>
          </div>

          {/* Discount type */}
          <div className="ocm-field">
            <label className="ocm-field-label">Discount type</label>
            <select
              className="ocm-select"
              value={values.discount_type}
              onChange={(e) => set("discount_type", e.target.value)}>
              {discountTypeOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.name}</option>
              ))}
            </select>
          </div>

          {/* Discount value */}
          <div className="ocm-field">
            <label className="ocm-field-label">Discount value</label>
            <div className="ocm-input-prefix">
              <span className="ocm-prefix-symbol">
                {values.discount_type === "percentage" ? "%" : "\u20B9"}
              </span>
              <input
                type="number"
                placeholder="Eg: 10"
                value={values.discount_val}
                onChange={(e) => set("discount_val", e.target.value)}
              />
            </div>
          </div>

          {/* Max allowed discount (only for percentage) */}
          {values.discount_type === "percentage" && (
            <div className="ocm-field">
              <label className="ocm-field-label">Max allowed discount</label>
              <div className="ocm-input-prefix">
                <span className="ocm-prefix-symbol">&#8377;</span>
                <input
                  type="number"
                  placeholder="Eg: 50"
                  value={values.maximum_allowed_discount}
                  onChange={(e) => set("maximum_allowed_discount", e.target.value)}
                />
              </div>
            </div>
          )}

          {/* Status toggle */}
          <div className="ocm-status-row">
            <span className="ocm-field-label" style={{ fontSize: "0.85rem" }}>Status</span>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
              <span style={{ fontSize: "0.82rem", color: values.status ? "#2D6B4D" : "#D90429", fontWeight: 600 }}>
                {values.status ? "Active" : "Inactive"}
              </span>
              <input
                type="checkbox"
                checked={values.status}
                onChange={() => set("status", !values.status)}
                style={{ width: "1.1rem", height: "1.1rem", accentColor: "#2D6B4D", cursor: "pointer" }}
              />
            </label>
          </div>

          {/* Action buttons */}
          <div className="ocm-form-actions">
            <button type="button" className="ocm-btn ocm-btn--cancel" onClick={handleCancel}>
              Cancel
            </button>
            <button type="button" className="ocm-btn ocm-btn--save" onClick={handleSubmit}>
              {!isEdit ? "Create" : "Update"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
